import { AUTH_KEY, CLIENT_AUTH_KEY } from '../auth/const';

export function parseCookie(cookieHeader: string) {
  const allCookies = cookieHeader.split(';');
  let authCookie: string | undefined;
  let refreshCookie: string | undefined;
  for (const cookie of allCookies) {
    if (cookie.startsWith(`${AUTH_KEY}=`) || cookie.startsWith(`${CLIENT_AUTH_KEY}=`)) {
      authCookie = cookie;
    } else if (cookie.startsWith('_rt=')) {
      refreshCookie = cookie;
    }
  }
  return {
    authCookie,
    refreshCookie,
    authToken: authCookie?.split('=')[1],
    refreshToken: refreshCookie?.split('=')[1],
  };
}
